export var DisplayType;
(function (DisplayType) {
    DisplayType["FIXED_WIDE"] = "fixed-wide";
    DisplayType["CONSTRAINED"] = "constrained";
})(DisplayType || (DisplayType = {}));
export var BackgroundColour;
(function (BackgroundColour) {
    BackgroundColour["LIGHTGREY"] = "lightgrey";
})(BackgroundColour || (BackgroundColour = {}));
